import { useMemo } from 'react';
import * as style from './style.css';
import { UIText2, UIText3 } from '@cian/ui-kit';

interface ILayoutsLinkProps {
  layoutCount: string;
  layoutsUrl: string;
  priceRange: string;
  roomCountText: string;
  onRoomLinkClick(): void;
}

export const LayoutsLink = ({
  layoutCount,
  layoutsUrl,
  roomCountText,
  priceRange,
  onRoomLinkClick,
}: ILayoutsLinkProps) => {
  const count = useMemo(() => Number.parseInt(layoutCount, 10), [layoutCount]);

  return (
    <div className={style['layout-link-block']}>
      <div>
        <UIText2>{roomCountText}</UIText2>
        <UIText3>{priceRange}</UIText3>
        <UIText3 color="text-main-default">
          <a
            className={style['layout-link']}
            href={layoutsUrl}
            target="_blank"
            rel="noreferrer"
            onClick={onRoomLinkClick}
          >
            {layoutCount}
          </a>
        </UIText3>
      </div>
      <UIText2 color="text-main-default">
        <a
          className={style['layout-link']}
          href={layoutsUrl}
          target="_blank"
          rel="noreferrer"
          onClick={onRoomLinkClick}
        >
          {count}
        </a>
      </UIText2>
    </div>
  );
};
